var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoFooterPablo = function SvgLogoFooterPablo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 52 53"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E2B0A5",
    stroke: "#E2B0A5",
    strokeWidth: 2.435,
    d: "M22.875 40.164h20.363q.053.002.132 0a4.126 4.126 0 0 0 1.682-.384 3.34 3.34 0 0 0 1.39-1.197c.392-.599.603-1.344.603-2.228 0-.878-.205-1.62-.6-2.214a3.14 3.14 0 0 0-1.415-1.157 4.038 4.038 0 0 0-1.796-.285H24.196c-1.676 0-2.011-.512-2.071-.615a.65.65 0 0 1-.084-.377c1.219-5.077 3.572-8.532 6.35-10.633 2.79-2.11 6.08-2.91 9.269-2.561 6.367.696 12.427 6 13.047 14.878.318 4.555-.403 7.863-1.59 10.272a12 12 0 0 1-4.595 5.039c-1.738 1.058-3.527 1.583-4.894 1.84-.68.129-1.248.19-1.64.218q-.294.02-.445.023l-.03.001-.077.001H4.086c3.124-5.564 7.522-8.22 11.268-9.493a22 22 0 0 1 5.839-1.128z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#E2B0A5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.436,
    d: "M2 51.668V16.61S1.797.761 20.687 2.081s23.156 26.013 1.828 31.093c0 0-2.438.508-2.438-3.353V10.718s.305-2.54-2.437-2.54-2.59 2.591-2.59 2.591v20.374c.001-.001 1.169 13.92-13.05 20.524"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2B0A5",
    stroke: "#E2B0A5",
    strokeWidth: 2.435,
    d: "M12.313 31.37c.035.46.591 9.483-7.566 15.509V16.61c0 .027-.002-1.21.433-2.887.437-1.682 1.295-3.736 2.968-5.42 2.281-2.298 5.705-3.555 10.363-3.555.637 0 1.305.024 1.985.072 8.724.61 13.052 6.716 13.487 12.011a11.5 11.5 0 0 1-2.225 7.815c-1.706 2.306-4.529 4.382-8.917 5.605a5 5 0 0 1-.016-.432v-19c.034-.574.035-2.328-1.23-3.754-.7-.79-1.951-1.637-3.955-1.637-1.965 0-3.219.823-3.93 1.578-1.384 1.468-1.419 3.332-1.407 3.806V31.26l.005.054zm10.64-.55.001.004z"
  })));
};
export default SvgLogoFooterPablo;